"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _invoice = require("@/api/invoice");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InvoiceDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    invoiceNo: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      detailLoading: false,
      detailInfo: {},
      detailList: [],
      detailTotal: 0,
      detailCurrentPage: 1,
      detailPageSize: 10
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      if (val && this.invoiceNo) {
        // 弹窗打开时重置分页并加载数据
        this.detailCurrentPage = 1;
        this.detailPageSize = 10;
        this.loadDetailData();
      }
    }
  },
  methods: {
    // 加载详情数据
    loadDetailData: function loadDetailData() {
      var _this = this;
      this.detailLoading = true;
      var params = {
        page: this.detailCurrentPage,
        limit: this.detailPageSize
      };
      (0, _invoice.getInvoiceInfo)(this.invoiceNo, params).then(function (res) {
        _this.detailInfo = res || {};
        _this.detailList = res.detailList || [];
        _this.detailTotal = res.detailTotal || (res.detailList ? res.detailList.length : 0);
        _this.detailLoading = false;
      }).catch(function () {
        _this.detailLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
      // 重置数据
      this.detailCurrentPage = 1;
      this.detailPageSize = 10;
      this.detailInfo = {};
      this.detailList = [];
      this.detailTotal = 0;
    },
    handleDetailSizeChange: function handleDetailSizeChange(val) {
      this.detailPageSize = val;
      this.detailCurrentPage = 1;
      this.loadDetailData();
    },
    handleDetailPageChange: function handleDetailPageChange(val) {
      this.detailCurrentPage = val;
      this.loadDetailData();
    }
  }
};